import useOrdersSessionByTableQuery from "../queries/orderssessions/useOrdersSessionByTableQuery";
import useOrders from "./useOrders";

const usePosSessionOrdersHook = () => {
  const query = useOrdersSessionByTableQuery();
  const { data } = useOrders();
  const idKeys = Object.keys(query?.data?.order_ids || {});
  return data?.[0]?.filter((order) =>
    idKeys.includes(order?.order_information?.item_id?.toString()),
  );
};

export default usePosSessionOrdersHook;
